import { css } from 'aphrodite/no-important';
import React from 'react';

import styles from './styles';

interface Props {
  type: 'origin' | 'destination';
}

export const JourneyLegTrackIcon = ({ type }: Props) => (
  <div className={css(styles.trackItemMarkerContainer)}>
    <span className={css(styles.trackItemMarker)}>
      <span className={css(styles.trackItemDot)} />
      <span
        className={css(
          styles.trackItemPath,
          type === 'origin' ? styles.trackItemPathOrigin : styles.trackItemPathDestination
        )}
      />
    </span>
  </div>
);
